// use common.js, so we can consume the config modules in the build flow
module.exports = Object.freeze({
  appName: 'lp-le-management-console',
  appCode: 'mc',
  PRIVILEGES: {
    MC_VIEW_AND_ACCESS: '1857',
    MC_EDIT_AND_SAVE: '1858',
    MC_LPA_SAVE_HIGH_RISK: '1867',
  },
  defaultDialogWidth: '600px',
  COMPONENTS: {
    RADIO: 'radio', // must specify options, which is an array of { displayName: '', value: '' }
    DROPDOWN: 'dropdown', // must specify options, which is an array of { displayName: '', value: '' }
    JSON: 'json',
    TEXT: 'text',
    NUMBER: 'number', // same as float - allow floats (fraction)
    INTEGER: 'integer', // only allow integers (whole numbers)
    FLOAT: 'float', // same as number - allow floats (fraction)
    TOGGLE: 'toggle', // can specify enabledValue and disabledValue
  },
  SETTING_TYPES: {
    PROVISION: 'provision',
    SETTINGS: 'settings',
  },
  TOOL_FEATURE_TYPE_NAVIGATION: {
    INTERNAL: 'LEInternalNavigation',
    EXTERNAL: 'regularUrlNavigation',
    OPEN_MULTI_URL_TAB_INTERVAL: 6500,
  },
  MC_OBJECT_TYPE: {
    FEATURE_KEY: 'feature',
    SITESETTING_KEY: 'sitesetting',
    IFRAME_KEY: 'iframe',
  },
  ENVIRONMENT: {
    CI: 'ci',
    QA: 'qa',
    ALPHA: 'alpha',
    GA: 'ga',
  },
  AC_INTERNAL_ERROR_CODES: {
    DEFAULT_PERMISSION_UPDATE: 212,
    INSUFFICIENT_PRIVILEGES: 1205,
  },
  AC_SITE_SETTINGS_TYPES: {
    FLOAT: {
      value: 0,
      name: 'Float'
    },
    INTEGER: {
      value: 1,
      name: 'Integer'
    },
    STRING: {
      value: 2,
      name: 'String'
    },
    STRING_ARRAY: {
      value: 3,
      name: 'String Array'
    },
    JSON: {
      value: 4,
      name: 'JSON'
    },
  },
  useFakeData: false,
  useFakeDataForGetOnly: false,
});


